export default "$ yarn global add @vue/cli\n// OR\n$ npm install @vue/cli -g\n";